import React, { Component } from 'react';
import { Link } from 'react-router'
import store from '../../../store';
import { projectNameInCategory } from '../../actions/project-actions';
import Inview from 'react-inview';
import LazyLoad from 'react-lazy-load'
import MediaQuery from 'react-responsive';
import './categoryGallery.css';

class CategoryGallery extends Component {

  constructor(props) {
    super()
    this.props = props
    this.state = {
      imageVisible:false,
      width: window.innerWidth
    }
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  }

  handleInview = (event) => {
    let title = event.target.getAttribute('data-title')
    store.dispatch(projectNameInCategory(title))   
  }

  render() {
    return (
      <div className="categoryGallery--wrapper">
        {
          this.props.projects.map(function(project) {  
          if (project.acf.featured_image.type === 'image'){
           var media = <img src={project.acf.featured_image.url} className="image image--categoryGallery"/>
          }else{
            media = <video className="inline-video" playsInline autoPlay muted loop> <source src={project.acf.featured_image.url} type="video/mp4" /> </video>
          }
          const { width } = this.state
          const isMobile = width <= 767
          if (isMobile) {
            return(
              <LazyLoad className="categoryGallery--item" key={project.id} offsetBottom={250} debounce={false}>
                <Link to={`/story/${project.slug}`} data-title={project.title.rendered}>
                  <button className="categoryGallery-button">Enter</button>
                  {media}
                </Link> 
              </LazyLoad>
              ) 
            } else {
          return(
              <LazyLoad className="categoryGallery--item" key={project.id} offsetBottom={250} debounce={false}>
              <Inview onInview={this.handleInview} key={project.id + 1}>
                <Link to={`/story/${project.slug}`} data-title={project.title.rendered}>
                  <button className="categoryGallery-button">Enter</button>
                  {media}
                </Link> 
              </Inview>  
              </LazyLoad>
              ) 
            }  
          }.bind(this))
        } 
      </div> 
    )
  }
}

export default CategoryGallery;



/** WEBPACK FOOTER **
 ** ./src/js/components/category-gallery/index.js
 **/